<h2 mat-dialog-title>
  {{ data.id ? 'Edit Resource' : 'Add Resource' }} - {{ getResourceTypeName() }}
</h2>
<form (ngSubmit)="onSubmit()" #resourceForm="ngForm" autocomplete="off">
  <mat-dialog-content>
    <h3 class="section-title">Basic Information</h3>
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label>Name</mat-label>
      <input matInput name="name" [(ngModel)]="data.name" [disabled]="!!data.external" required />
      <mat-hint *ngIf="data.external">This resource is managed externally via SSO</mat-hint>
    </mat-form-field>
    
    <mat-form-field appearance="outline" style="width: 100%; margin-top: 1rem;">
      <mat-label>Capacity</mat-label>
      <input matInput type="number" min="1" [max]="getMaxCapacity()" name="capacity" [(ngModel)]="data.capacity" required />
      <mat-hint *ngIf="getMaxCapacity()">
        How many teams/groups can use this resource simultaneously (max: {{ getMaxCapacity() }})
      </mat-hint>
      <mat-hint *ngIf="!getMaxCapacity()">
        How many teams/groups can use this resource simultaneously
      </mat-hint>
    </mat-form-field>
    
    <div *ngIf="resourceTypeHasAttributes()">
      <h3 class="section-title">Attributes</h3>
      <div *ngFor="let attribute of getResourceTypeAttributes(); let i = index" class="attribute-field">
        <!-- Text attribute -->
        <mat-form-field *ngIf="attribute.type === 'text'" appearance="outline" style="width: 100%;">
          <mat-label>{{ attribute.name }}</mat-label>
          <input matInput
            [name]="'attr_' + attribute.id"
            [(ngModel)]="attributeValues[attribute.id]"
            [disabled]="!!attribute.external" />
          <mat-hint *ngIf="attribute.external">This attribute is managed externally via SSO</mat-hint>
        </mat-form-field>

        <!-- Number attribute -->
        <mat-form-field *ngIf="attribute.type === 'number'" appearance="outline" style="width: 100%;">
          <mat-label>{{ attribute.name }}</mat-label>
          <input matInput type="number"
            [name]="'attr_' + attribute.id"
            [(ngModel)]="attributeValues[attribute.id]"
            [disabled]="!!attribute.external" />
          <mat-hint *ngIf="attribute.external">This attribute is managed externally via SSO</mat-hint>
        </mat-form-field>

        <!-- Checkbox attribute (toggle style) -->
        <div *ngIf="attribute.type === 'checkbox'" class="toggle-field">
          <label class="toggle-container">
            <span class="toggle-label">{{ attribute.name }}</span>
            <div class="toggle-switch-container">
              <input type="checkbox"
                [name]="'attr_' + attribute.id"
                [(ngModel)]="attributeValues[attribute.id]"
                [disabled]="!!attribute.external">
              <span class="toggle-switch"></span>
            </div>
          </label>
          <span *ngIf="attribute.external" class="external-hint">This attribute is managed externally via SSO</span>
        </div>

        <!-- Select attribute -->
        <mat-form-field *ngIf="attribute.type === 'select'" appearance="outline" style="width: 100%;">
          <mat-label>{{ attribute.name }}</mat-label>
          <mat-select
            [name]="'attr_' + attribute.id"
            [(ngModel)]="attributeValues[attribute.id]"
            [disabled]="!!attribute.external">
            <ng-container *ngIf="getSelectOptions(attribute).length > 0; else noOptions">
              <mat-option *ngFor="let opt of getSelectOptions(attribute)" [value]="opt.slug">
                {{ opt.display }}
              </mat-option>
            </ng-container>
            <ng-template #noOptions>
              <mat-option disabled>No options</mat-option>
            </ng-template>
          </mat-select>
          <mat-hint *ngIf="attribute.external">This attribute is managed externally via SSO</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="!data.name || !data.resourceTypeId"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
